import { render, staticRenderFns } from "./EmployeeLeaveRecordsCard.vue?vue&type=template&id=0d3ab9f7&"
import script from "./EmployeeLeaveRecordsCard.vue?vue&type=script&lang=js&"
export * from "./EmployeeLeaveRecordsCard.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeLeaveRecordsCard.vue?vue&type=style&index=0&id=0d3ab9f7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports